import React from 'react';
import { Link } from 'react-router-dom';
import { isGiftFinderEnabled, giftFinderLinkLabel } from '../../giftFinder/giftFinderSettings';

export default function HomeAssistantCard({ site }) {
  const store = site?.store_copy || {};
  if (!store.home_assistant_enabled) return null;
  if (!isGiftFinderEnabled(store)) return null;

  const title = store.home_assistant_title || 'Need help choosing?';
  const lead =
    store.home_assistant_lead ||
    'Try our Gift Finder — answer a few quick questions and we’ll suggest the best options.';
  const button = store.home_assistant_button || giftFinderLinkLabel(store, 'home') || 'Start Gift Finder';

  return (
    <section className="home-assistant container my-3 my-lg-4">
      <div className="card border shadow-sm">
        <div className="card-body d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
          <div className="flex-grow-1">
            <p className="small text-muted mb-1">Smart assistant</p>
            <h2 className="h5 mb-1">{title}</h2>
            <p className="text-muted mb-0">{lead}</p>
          </div>
          <Link to="/gift-finder" className="btn btn-primary rounded-pill px-4 flex-shrink-0">
            {button}
          </Link>
        </div>
      </div>
    </section>
  );
}

